import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Search, Menu, X } from "lucide-react";
import SearchDialog from "./SearchDialog";

const link = "px-3 py-2 text-[0.78rem] uppercase tracking-[0.18em] font-semibold transition-colors";

export default function Navbar() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-bg/85 backdrop-blur-md border-b border-line" data-testid="site-navbar">
      <div className="max-w-8xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-home-link">
          <img src="https://customer-assets.emergentagent.com/job_suspicious-visvesvaraya-7/artifacts/cjbz0mfo_WhatsApp%20Image%202025-07-04%20at%2023.11.02_ca176646%20SQ.jpg" alt="The Where To Go" className="w-11 h-11 object-contain"/>
          <span className="flex items-baseline gap-2">
            <span className="font-serif text-2xl md:text-3xl leading-none">The Where To Go</span>
            <span className="text-[0.6rem] uppercase tracking-[0.3em] text-muted hidden md:inline">Documentary travel</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/" end className={({isActive}) => `${link} ${isActive ? "text-olive" : "text-ink hover:text-olive"}`} data-testid="nav-home">Home</NavLink>
          <NavLink to="/destinations" className={({isActive}) => `${link} ${isActive ? "text-olive" : "text-ink hover:text-olive"}`} data-testid="nav-destinations">Destinations</NavLink>
          <NavLink to="/map" className={({isActive}) => `${link} ${isActive ? "text-olive" : "text-ink hover:text-olive"}`} data-testid="nav-map">Map</NavLink>
          <NavLink to="/about" className={({isActive}) => `${link} ${isActive ? "text-olive" : "text-ink hover:text-olive"}`} data-testid="nav-about">About</NavLink>
          <button onClick={() => setSearchOpen(true)} className={`${link} text-ink hover:text-olive flex items-center gap-1`} data-testid="nav-search-btn">
            <Search size={14} strokeWidth={1.7}/> Search
          </button>
        </nav>

        <button className="md:hidden p-2" onClick={() => setOpen(o => !o)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={20}/> : <Menu size={20}/>}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-bg border-t border-line" data-testid="mobile-menu">
          {[
            ["/", "Home"], ["/destinations", "Destinations"], ["/map", "Map"],
            ["/about", "About"],
          ].map(([to, label]) => (
            <button key={to} onClick={() => { setOpen(false); navigate(to); }} className="block w-full text-left px-6 py-4 border-b border-line uppercase tracking-[0.18em] text-sm font-semibold">{label}</button>
          ))}
          <button onClick={() => { setOpen(false); setSearchOpen(true); }} className="block w-full text-left px-6 py-4 uppercase tracking-[0.18em] text-sm font-semibold">Search</button>
        </div>
      )}

      <SearchDialog open={searchOpen} onOpenChange={setSearchOpen} />
    </header>
  );
}
